import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ctaPreFooterData } from "./cta-prefooter-data";
import sharedStyles from "../../car-reviews-v2.module.css";
import styles from "./cta-prefooter.module.css";
import cx from "classnames";
import { CtaButton } from "../cta-button";
import { EventNames, TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { datadogRum } from "@datadog/browser-rum";
import { Datadog } from "@cinch-nx/landing-ui-shared";
var Actions = Datadog.Actions, Context = Datadog.Context;
export var CtaPreFooter = function() {
    var ctaButton = "View all car reviews";
    var trackEvent = useAnalytics().trackEvent;
    var handleClick = function() {
        trackEvent({
            eventName: "Car Review - ".concat(ctaButton),
            type: TrackingEventTypes.ADOBE,
            data: {
                event: {
                    name: EventNames.click,
                    category: "view all car reviews",
                    label: "cta"
                }
            }
        });
        datadogRum.addAction(Actions.CLICK_CAR_REVIEW_CTA_PREFOOTER, {
            service: Context.CAR_REVIEW,
            squad: Context.SQUAD,
            page: window.location.pathname,
            value: "cta prefooter"
        });
    };
    return /*#__PURE__*/ _jsxs("section", {
        className: cx(sharedStyles.inner, styles.ctaPreFooterContainer),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.ctaPreFooterTextWrapper,
                children: [
                    /*#__PURE__*/ _jsx("h2", {
                        className: styles.ctaPreFooterTitle,
                        children: ctaPreFooterData.title
                    }),
                    /*#__PURE__*/ _jsxs("p", {
                        className: styles.ctaPreFooterDataBody,
                        children: [
                            ctaPreFooterData.body,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(CtaButton, {
                href: "/reviews",
                className: styles.ctaButton,
                onClick: function() {
                    return handleClick();
                },
                children: ctaButton
            })
        ]
    });
};
